import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  CircularProgress,
  Divider
} from '@mui/material';
import {
  PersonAdd as PersonAddIcon,
  Share as ShareIcon,
  Email as EmailIcon
} from '@mui/icons-material';

const IndicarAmigoPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' as 'success' | 'error'
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Aqui você implementaria a lógica para enviar o convite
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulação de API
      
      setSnackbar({
        open: true,
        message: 'Convite enviado com sucesso!',
        severity: 'success'
      });
      
      setEmail('');
      setMensagem('');
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Erro ao enviar convite. Tente novamente.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Indique um Amigo
        </Typography>

        <Paper sx={{ p: 3, mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <PersonAddIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Envie um Convite</Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />

          <Typography variant="body1" sx={{ mb: 3 }}>
            Compartilhe a experiência do Vendedor Virtual com seus amigos e ganhe benefícios exclusivos!
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email do Amigo"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  helperText="Digite o email do seu amigo para enviar o convite"
                  InputProps={{
                    startAdornment: <EmailIcon sx={{ mr: 1, color: 'action.active' }} />
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Mensagem Personalizada"
                  value={mensagem}
                  onChange={(e) => setMensagem(e.target.value)}
                  helperText="Adicione uma mensagem personalizada para seu amigo (opcional)"
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={loading ? <CircularProgress size={20} /> : <ShareIcon />}
                  disabled={loading}
                  fullWidth
                >
                  {loading ? 'Enviando...' : 'Enviar Convite'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ShareIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Benefícios da Indicação</Typography>
          </Box>
          <Divider sx={{ mb: 3 }} />

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Para você:
              </Typography>
              <ul>
                <li>1 mês de plano Premium gratuito</li>
                <li>Recursos exclusivos desbloqueados</li>
                <li>Suporte prioritário</li>
                <li>Descontos especiais</li>
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Para seu amigo:
              </Typography>
              <ul>
                <li>7 dias de trial Premium</li>
                <li>Acesso a todos os recursos</li>
                <li>Suporte dedicado</li>
                <li>Desconto especial na primeira assinatura</li>
              </ul>
            </Grid>
          </Grid>
        </Paper>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default IndicarAmigoPage; 